import Company, { CompanyBase } from "models/resources/company.model";
import User from "models/resources/user.model";

export const userCompanies = (user: User) => {
  return user?.users_companies.reduce((acc: number[], curr: CompanyBase) => {
    return [...acc, curr.id];
  }, []);
};
